import React, { useCallback, useEffect, useState } from "react";

import api from "../../util/panelApi";
import { PageHead, Tiles } from "./kit";

const cell = { padding: "6px 8px", border: "1px solid #E5E7EB", borderRadius: 6, fontSize: 13 };
const small = { fontSize: 12, color: "#6B7280" };

const KINDS = [
  ["login", "Günlük ödülü al"],
  ["chatCount", "Mesaj yaz"],
  ["roomMinutes", "Odada/yayında dakika"],
  ["giftCount", "Hediye adedi"],
  ["giftCoin", "Hediye coini"],
  ["followCount", "Takip et"],
];

/// Gorev merkezi: gunluk ve haftalik gorevler.
const Tasks = () => {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const r = await api.config();
    if (r?.status) {
      setCfg({
        tasksEnabled: r.config.tasksEnabled !== false,
        tasks: r.config.tasks || [],
      });
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const save = async () => {
    const bad = cfg.tasks.find((t) => !t.key || !t.label);
    if (bad) return window.alert("Her görevin anahtarı ve adı olmalı.");
    const keys = cfg.tasks.map((t) => t.key);
    if (new Set(keys).size !== keys.length) return window.alert("Görev anahtarları benzersiz olmalı.");
    setSaving(true);
    const r = await api.saveConfig(cfg);
    setSaving(false);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    load();
  };

  const set = (i, k, v) => setCfg({ ...cfg, tasks: cfg.tasks.map((t, j) => (i === j ? { ...t, [k]: v } : t)) });
  const add = () =>
    setCfg({
      ...cfg,
      tasks: [
        ...cfg.tasks,
        { key: `t_${Date.now().toString(36)}`, kind: "giftCount", period: "day", target: 1, coin: 50, label: "", enabled: true },
      ],
    });
  const del = (i) => setCfg({ ...cfg, tasks: cfg.tasks.filter((_, j) => j !== i) });

  if (!cfg) return <div className="badu-empty">Yükleniyor…</div>;

  return (
    <>
      <PageHead
        title="Görev Merkezi"
        sub="Kullanıcı görevi tamamlayınca coin kazanır. Günlük görevler her gece, haftalık görevler pazartesi sıfırlanır."
      />

      <Tiles
        items={[
          { label: "Durum", value: cfg.tasksEnabled ? "Açık" : "Kapalı" },
          { label: "Görev sayısı", value: cfg.tasks.length },
          { label: "Günlük toplam ödül", value: cfg.tasks.filter((t) => t.period !== "week").reduce((a, t) => a + (Number(t.coin) || 0), 0) },
        ]}
      />

      <div className="card">
        <div className="card-body">
          <label style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
            <input
              type="checkbox"
              checked={cfg.tasksEnabled}
              onChange={(e) => setCfg({ ...cfg, tasksEnabled: e.target.checked })}
            />
            <b>Görev merkezi açık</b>
          </label>

          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Açık</th>
                  <th>Görev adı</th>
                  <th>Tür</th>
                  <th>Dönem</th>
                  <th>Hedef</th>
                  <th>Ödül</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {cfg.tasks.map((t, i) => (
                  <tr key={i}>
                    <td>
                      <input
                        type="checkbox"
                        checked={t.enabled !== false}
                        onChange={(e) => set(i, "enabled", e.target.checked)}
                      />
                    </td>
                    <td>
                      <input style={{ ...cell, width: 260 }} value={t.label || ""} onChange={(e) => set(i, "label", e.target.value)} />
                      <div style={small}>{t.key}</div>
                    </td>
                    <td>
                      <select style={{ ...cell, width: 180 }} value={t.kind} onChange={(e) => set(i, "kind", e.target.value)}>
                        {KINDS.map(([k, l]) => (
                          <option key={k} value={k}>
                            {l}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <select style={{ ...cell, width: 110 }} value={t.period || "day"} onChange={(e) => set(i, "period", e.target.value)}>
                        <option value="day">Günlük</option>
                        <option value="week">Haftalık</option>
                      </select>
                    </td>
                    <td>
                      <input style={{ ...cell, width: 110 }} type="number" value={t.target || 1} onChange={(e) => set(i, "target", Number(e.target.value))} />
                    </td>
                    <td>
                      <input style={{ ...cell, width: 110 }} type="number" value={t.coin || 0} onChange={(e) => set(i, "coin", Number(e.target.value))} />
                    </td>
                    <td>
                      <button className="btn btn-sm btn-outline-danger" onClick={() => del(i)}>
                        Sil
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="d-flex" style={{ gap: 8, marginTop: 10 }}>
            <button className="btn btn-outline-secondary btn-sm" onClick={add}>
              Görev ekle
            </button>
            <button className="btn btn-primary btn-sm" disabled={saving} onClick={save}>
              {saving ? "Kaydediliyor…" : "Kaydet"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tasks;
